module.exports = [{
      plugin: require('/opt/render/project/src/frontend/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
